import { render } from "./HeaderActions.vue?vue&type=template&id=edda7d06&scoped=true"
import script from "./HeaderActions.vue?vue&type=script&lang=js"
export * from "./HeaderActions.vue?vue&type=script&lang=js"

import "./HeaderActions.vue?vue&type=style&index=0&id=edda7d06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edda7d06"]])

export default __exports__